import React from "react";
import Grid from "@material-ui/core/Grid";
import Skeleton from '@material-ui/lab/Skeleton';

export default function SkeletonInsideCard(props) {
  return (
    <React.Fragment>
      <Grid item container>
        <Skeleton animation="wave" variant="rect" /* width={1320} */ height={310} style={{ borderRadius: 16, width: '100%' }} />
      </Grid>
    </React.Fragment>
  )
}